const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class LogoCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els.slide?.exists) return
    if (this.els.slide.elements.length < 2) return

    this.setupCarousel()

    this.resizeObserver = new ResizeObserver(() => {
      this.setupCarousel()
    })

    this.resizeObserver.observe(this.els.slides.element.parentElement)
  }

  setupCarousel () {
    const slidesEl = this.els.slides.element
    const slideEls = this.els.slide.elements

    if (!slidesEl || !slideEls.length) return

    const spacing = 12

    /*
     * Destroy the existing carousel before measuring.
     */
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    slidesEl.removeAttribute('data-initialised')
    slidesEl.removeAttribute('data-keen-slider-disabled')

    const viewportWidth = slidesEl.parentElement.clientWidth
    const slideWidth = slideEls[0].getBoundingClientRect().width

    const slidesWidth =
      slideWidth * slideEls.length + spacing * (slideEls.length - 1)

    /*
     * All slides fit.
     *
     * Don't initialise KeenSlider.
     * CSS will centre the slides.
     */
    if (slidesWidth <= viewportWidth) {
      return
    }

    /*
     * Slides don't fit.
     *
     * Initialise KeenSlider.
     */
    this.carousel = new KeenSlider(
      slidesEl,
      {
        selector: this.els.slide.selector,

        defaultAnimation: {
          duration: 1500,
        },

        loop: true,
        mode: 'snap',

        slides: {
          origin: 'center',
          perView: 'auto',
          spacing,
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }

  disconnectedCallback () {
    this.resizeObserver?.disconnect()

    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
    }

    super.disconnectedCallback?.()
  }
}

if (!customElements.get('logo-carousel')) {
  customElements.define('logo-carousel', LogoCarousel)
}
